module.exports = __webpack_public_path__ + "img/copy.4aa8934c.svg";